"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CJFormTabLayout = exports.CJFormTab = exports.useCJFormTab = exports.CJFormTabContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var R = __importStar(require("../../utils/ramda"));
var CJFormContext_1 = require("./CJFormContext");
var Row_1 = require("../../components/Row");
var classnames_1 = __importDefault(require("classnames"));
var TabLayout_1 = require("../../components/TabLayout");
var react_2 = __importDefault(require("react"));
var MDIcon_1 = require("../../components/MDIcon");
var CJFormLayout_1 = require("./CJFormLayout");
exports.CJFormTabContext = react_2.default.createContext({
  tabId: "",
  names: [],
  addName: R.N,
  removeName: R.N
});
(0, MDIcon_1.preloadIcons)("alert-circle");
var useCJFormTab = function (defaultTab) {
  var _a = __read((0, TabLayout_1.useTabLayout)(defaultTab), 2),
    selectedId = _a[0],
    selectTab = _a[1];
  return {
    selectedId: selectedId,
    selectTab: selectTab
  };
};
exports.useCJFormTab = useCJFormTab;
var CJFormTab = function (_a) {
  var children = _a.children,
    label = _a.label,
    tabId = _a.id,
    className = _a.className,
    restProps = __rest(_a, ["children", "label", "id", "className"]);
  var _b = __read((0, react_1.useState)([]), 2),
    names = _b[0],
    setNames = _b[1];
  var addName = function (name) {
    if (!name) return;
    var newData = function (data) {
      return R.uniq(R.append(name, data));
    };
    setNames(newData);
  };
  var removeName = function (name) {
    if (!name) return;
    var newData = R.reject(function (n) {
      return n === name;
    });
    setNames(newData);
  };
  var formState = (0, react_1.useContext)(CJFormContext_1.CJFormContext).formState;
  var hasError = R.any(function (n) {
    return !R.isNothing(formState.errors[n]);
  }, names);
  var errorLabel = (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
    align: "center",
    gap: "medium"
  }, {
    children: [(0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
      icon: "alert-circle",
      className: "vsx-cjform-tab-error-label",
      color: "var(--color-icon-critical)"
    }), (0, jsx_runtime_1.jsx)("span", {
      children: label
    })]
  }));
  var displayLabel = (0, react_1.useMemo)(function () {
    return hasError ? errorLabel : label;
  }, [hasError]);
  return (0, jsx_runtime_1.jsx)(TabLayout_1.Tab, __assign({
    className: (0, classnames_1.default)("vsx-cjform-tab", className),
    id: tabId,
    label: displayLabel
  }, restProps, {
    children: (0, jsx_runtime_1.jsx)(exports.CJFormTabContext.Provider, __assign({
      value: {
        tabId: tabId,
        names: names,
        addName: addName,
        removeName: removeName
      }
    }, {
      children: (0, jsx_runtime_1.jsx)(CJFormLayout_1.CJFormLayoutGrid, {
        children: children
      })
    }))
  }));
};
exports.CJFormTab = CJFormTab;
var CJFormTabLayout = function (_a) {
  var children = _a.children,
    className = _a.className,
    restProps = __rest(_a, ["children", "className"]);
  var _b = (0, react_1.useContext)(CJFormContext_1.CJFormContext),
    selectTab = _b.selectTab,
    selectedId = _b.selectedId;
  return (0, jsx_runtime_1.jsx)(TabLayout_1.TabLayout, __assign({}, restProps, {
    className: (0, classnames_1.default)("vsx-cjform-fullwidth", className),
    selectTab: selectTab !== null && selectTab !== void 0 ? selectTab : R.N,
    selectedId: selectedId !== null && selectedId !== void 0 ? selectedId : "",
    lazy: false
  }, {
    children: children
  }));
};
exports.CJFormTabLayout = CJFormTabLayout;